import { options_title, optionsFull_goToQuickOptions } from './CategoriesColumn.locstring.json';
import loc from 'owa-localize';
import { getStore, collectedOptions } from 'owa-options-store';
import { observer } from 'mobx-react-lite';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { OptionCategory } from 'owa-options-core';
import { AnimationClassNames } from '@uifabric/styling';
import * as React from 'react';
import { selectCategory } from 'owa-options-orchestration';
import { hideFullOptions } from 'owa-options-core';
import FullOptionSearch from './FullOptionSearch';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { useOptionLayout, OptionLayout } from './hooks/useOptionLayout';
const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

interface CategoryEntryProps {
    category: OptionCategory;
    onCategorySelect?(category: OptionCategory): void;
    isSelected: boolean;
}

export const CategoryEntry = observer(function CategoryEntry({
    category,
    onCategorySelect,
    isSelected,
}: CategoryEntryProps) {
    let buttonStyles = {
        root: className(styles.category, {
            selectedCategory: isSelected,
        }),
        flexContainer: styles.flexContainer,
        label: styles.categoryLabel,
    };

    let iconProps = {
        iconName: category.icon,
        styles: {
            root: styles.categoryIcon,
        },
    };
    const onClick = React.useCallback(() => (onCategorySelect || selectCategory)(category), [
        category,
        onCategorySelect,
    ]);
    return (
        <ActionButton
            styles={buttonStyles}
            key={category.key}
            onClick={onClick}
            iconProps={iconProps}
            text={loc(category.titleStringKey) as string}
            role="tab"
        />
    );
});

interface CategoriesColumnProps {
    selectedCategoryKey?: string;
    onCategorySelect?(category: OptionCategory): void;
}

export const CategoriesColumn = observer(function CategoriesColumn({
    selectedCategoryKey = getStore().currentCategoryKey,
    onCategorySelect,
}: CategoriesColumnProps) {
    const layout = useOptionLayout();
    return (
        <div
            className={className(
                styles.categoriesColumn,
                layout === OptionLayout.OneColumn && AnimationClassNames.slideRightIn20,
                layout === OptionLayout.OneColumnNarrow && styles.dropShadow
            )}
            role="tablist">
            <span className={styles.title} role="heading" aria-level={2}>
                {loc(options_title)}
            </span>
            <FullOptionSearch />
            <FocusZone direction={FocusZoneDirection.vertical}>
                {collectedOptions().map(category => (
                    <CategoryEntry
                        category={category}
                        key={category.key}
                        onCategorySelect={onCategorySelect}
                        isSelected={selectedCategoryKey === category.key}
                    />
                ))}
            </FocusZone>
            <ActionButton
                className={styles.viewQuickSettings}
                onClick={goToQuickOptions}
                text={loc(optionsFull_goToQuickOptions)}
            />
        </div>
    );
});

function goToQuickOptions() {
    hideFullOptions(true /* showQuickOptions */);
}
